import MerchantEmailVerifyPage from '../../../../components/merchant/email-verify/MerchantEmailVerifyPage'

export default function VerifyEmail() {
  return <MerchantEmailVerifyPage />
}
